import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";

interface WaitlistBannerProps {
  variant?: "full" | "compact";
  onJoinClick?: () => void;
}

const WaitlistBanner = ({ variant = "full", onJoinClick }: WaitlistBannerProps) => {
  const isCompact = variant === "compact";

  return (
    <section className={isCompact ? "mt-8" : "container mx-auto px-6 pb-16"}>
      <div
        className={`relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/10 via-background to-accent/10 ${
          isCompact ? "px-6 py-6 text-center" : "px-8 md:px-16 py-12 md:py-16"
        }`}
      >
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,hsl(160_84%_45%/0.08),transparent_60%)]" />
        <div className="relative z-10">
          {!isCompact && (
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary/20 bg-primary/5 text-xs text-primary mb-4">
              <Sparkles className="w-3 h-3" />
              Early Access
            </div>
          )}
          <h3
            className={`font-bold mb-2 ${
              isCompact ? "text-lg" : "text-2xl md:text-3xl"
            }`}
          >
            Get Early Access to Unlimited Analysis
          </h3>
          <p
            className={`text-muted-foreground mb-5 ${
              isCompact ? "text-sm max-w-sm mx-auto" : "text-base max-w-xl"
            }`}
          >
            Join our waitlist to be first in line when we launch full access with
            unlimited scans, priority support, and advanced features.
          </p>
          <Button
            onClick={onJoinClick}
            size={isCompact ? "default" : "lg"}
            className={isCompact ? "" : "px-8 text-base font-semibold glow-primary"}
          >
            Join the Waitlist
            <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WaitlistBanner;
